import { createApp } from 'vue'
import App from './App.vue'
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import {md5 } from 'js-md5';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { createI18n } from 'vue-i18n';
import LangEnUs from './assets/i18n/en' // 多语言配置文件-英文
import LangES from './assets/i18n/es' // 多语言配置文件-西班牙文
import LangTH from './assets/i18n/th' // 多语言配置文件-泰文

// =========================================================
// 校验码相关常量
// =========================================================
const ALPHABET_CHECK = "xT7mQkY2hRjP5eWnVzC8aKqU4fBgM6rHsD9wJcXpNyL3uEtSAZ";
const CHECK_BASE = 50; // 字母表长度

/**
 * 计算校验码（基于自定义字母表）
 * @param {string} code9 - 前9位编码
 * @returns {string} 第10位校验码字符
 */
function calcChecksum(code9) {
    let total = 0;
    for (let i = 0; i < code9.length; i++) {
        const c = code9[i];
        const value = ALPHABET_CHECK.indexOf(c);
        if (value === -1) {
            throw new Error(`Invalid character: ${c}`);
        }
        total += value * (i + 1);
    }
    const checksumIndex = total % CHECK_BASE;
    return ALPHABET_CHECK[checksumIndex];
}

/**
 * 验证10位编码的校验码是否正确
 * @param {string} code10 - 10位完整编码
 * @returns {boolean} 校验结果
 */
function verifyCode(code10) {
    if (code10.length !== 10) {
        return false;
    }
    
    const body = code10.substring(0, 9);
    const checksum = code10.substring(9, 10);
    
    try {
        const expected = calcChecksum(body);
        return checksum === expected;
    } catch (error) {
        console.error('校验码验证失败:', error);
        return false;
    }
}

/**
 * 生成10位编码（包含校验码）
 * @param {string} code9 - 前9位编码
 * @returns {string} 10位完整编码
 */
function generateCode(code9) {
    if (code9.length !== 9) {
        throw new Error('输入必须是9位编码');
    }
    const checksum = calcChecksum(code9);
    return code9 + checksum;
}

// 准备翻译的语言环境信息
const messages = {
  en:LangEnUs,
  es:LangES,
  th:LangTH,
}

// 通过选项创建 VueI18n 实例
const i18n =  createI18n({
  legacy: false, // 使用Composition API
  locale: navigator.language.split('-')[0], // 设置地区
  fallbackLocale: 'en', // 备选语言
  messages // 设置地区信息
})




function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

function idCheck(id){
    // 模式1: 32位ID校验（原有MD5逻辑）
    if(id.length == 32){
      let start =  id.substr(0, 16);
      let end =  id.substr(16, 16);
      if(end == md5(start).substr(0,16)  ){
        return true;
      }
    }
    
    // 模式2: 10位编码校验（新字母表校验码逻辑）
   else if(id.length == 10){
      return verifyCode(id);
    }
    
    return false;
}


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB8te3tP_AQMUXN4GDjEm5GNbQ4L9iKSsk",
    authDomain: "pet-tag-4f8ae.firebaseapp.com",
    projectId: "pet-tag-4f8ae",
    storageBucket: "pet-tag-4f8ae.appspot.com",
    messagingSenderId: "1105731235",
    appId: "1:1105731235:web:2db43ebff9a365312ee916"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
    // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
 const appCheck = initializeAppCheck(app, {
  //6Lc6scQpAAAAAGhs9dAiuKwN8bGR9XB88uZqWEmm
  //6LekSM0oAAAAADUvxv8txExiURW_QJ7dNYxFcVOv
  provider: new ReCaptchaEnterpriseProvider('6Lc6scQpAAAAAGhs9dAiuKwN8bGR9XB88uZqWEmm'),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true
});

  const storage = getStorage(app);
  const db = getFirestore(app);


  
//appCheck
  export {storage,app,appCheck,db,i18n,getQueryString,idCheck, generateCode, verifyCode}

  const app1 = createApp(App);
  app1.use(i18n);
  app1.mount('#app');
